const getWindow = () => {
    try {
        if (typeof window !== "undefined") return window;
    } catch {
        return undefined;
    }
    return undefined;
};

const win = getWindow();
export const isLocal =
    !!(win &&
        (win.location.hostname === "localhost" ||
            win.location.hostname === "127.0.0.1"));

export const isTest = import.meta.env?.VITE_APP_ENV === "test";
export const isDev = import.meta.env?.VITE_APP_ENV === "dev";
export const isDevOrLocal = isDev || isLocal || isTest;